module.exports = __webpack_public_path__ + "img/layout_form_icon.caa37610.svg";